import {
    DEALERADDUPDATEDIVISONLIST_SUCCESS,
    DEALERADDUPDATEDIVISONLIST_FAILED,
    RESET_DEALERADDUPDATEDIVISONLIST,
    LOADING_DEALERADDUPDATEDIVISONLIST,
    NETWORK_ERROR_DEALERADDUPDATEDIVISONLIST
} from "../types/index"


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDUPDATEDIVISONLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDUPDATEDIVISONLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDUPDATEDIVISONLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDUPDATEDIVISONLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDUPDATEDIVISONLIST:
            return (state = initialState);
        default:
            return state;
    }
};